import axios from 'axios';
import { csrfToken } from 'rails-ujs';
import { AppContext } from '../store/context';
const InternalConfig = AppContext.InternalConfig;

const http: any = axios.create();
http.defaults.headers['X-CSRF-TOKEN'] = csrfToken();
http.interceptors.request.use(
    config => {
        return config;
    },
    error => Promise.reject(error)
);

export default http;
